export default {
  'unavailable:btn': 'Kaspi.kz бас бетіне қайту',
  'unavailable:title': 'Балаға арналған Kaspi Gold <br> картасын {0}:00 аштыруға болады'
}
